import { message } from "antd";
import { client } from "../../../actions";
import { authHeader } from "../../../helpers/auth-header";

const getLastComment = async (entityId) => {
	try {
		const response = await client.get(`/Docs/last_note/${entityId}`, {
			headers: authHeader(),
		});
		return response.data;
	} catch (error) {
		message.error("Произошла ошибка при загрузке последнего комментария");
		console.error(error);
		return [];
	}
};

export default getLastComment;
